import * as React from 'react';
import { ScrollFade } from '../../ScrollFade';
import * as styles from './TgbPrimaryTemplate.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TgbPrimaryTemplate = function TgbPrimaryTemplate(props) {
  var image = props.image,
    title = props.title,
    description = props.description,
    phone = props.phone,
    footnote = props.footnote,
    buttonText = props.buttonText,
    url = props.url,
    label = props.label;
  var isVisibleFooter = !!buttonText || !!footnote;
  return /*#__PURE__*/_jsxs("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer noopener nofollow",
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['image'],
        children: [/*#__PURE__*/_jsx("img", {
          src: image,
          alt: title
        }), label && /*#__PURE__*/_jsx("div", {
          className: styles['label'],
          children: label
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['aside'],
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles['title'],
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: styles['text'],
          children: description
        }), phone && /*#__PURE__*/_jsx("div", {
          className: styles['phone'],
          children: phone
        })]
      })]
    }), isVisibleFooter && /*#__PURE__*/_jsxs("div", {
      className: styles['footer'],
      children: [footnote && /*#__PURE__*/_jsxs("div", {
        className: styles['note'],
        children: [footnote, /*#__PURE__*/_jsx(ScrollFade, {
          size: 18
        })]
      }), buttonText && /*#__PURE__*/_jsx("div", {
        className: styles['button'],
        children: buttonText
      })]
    })]
  });
};